import React, { useState } from "react";
import { Box, makeStyles, Typography, Button } from "@material-ui/core";
import InputWithLabel from "../Inputs/InputWithLabel";
import Label from "../Misc/Label";

import CustomCheckbox from "../Inputs/CustomCheckbox";

const useStyles = makeStyles((theme) => ({
  container: {
    // background: "#FFFFFF",
    // boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    // borderRadius: "8px",
    // padding: 24,
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: 6,
  },

  headingDesc: {
    fontWeight: "400",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    color: "rgba(0,0,0, 0.46)",
  },

  stepHeader: {
    marginBottom: "3rem",
  },
}));

const ProjectRegistrationStepFive = () => {
  const classes = useStyles();

  const [contactName, setContactName] = useState("");
  const [telegramId, setTelegramId] = useState("");
  const [checkBoxes, setCheckBoxes] = useState({
    1: true,
    2: true,
    3: false,
    4: false,
  });

  return (
    <Box className={classes.container}>
      {/* <Box className={classes.stepHeader}>
        <Typography className={classes.pageHeading}>Step 3</Typography>

        <Typography className={classes.headingDesc}>
          Provide contact details for project founders
        </Typography>
      </Box> */}

      <Box>
        <InputWithLabel
          label="Name"
          value={contactName}
          setValue={setContactName}
          placeholder="John Doe"
        />
        <InputWithLabel
          label="Wallet Address"
          value={telegramId}
          setValue={setTelegramId}
          placeholder="0x1e...efd2"
        />

        <Box marginBottom="2.4rem">
          <Label label="Social Media Platforms" />
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <CustomCheckbox
              label="Twitter"
              checked={checkBoxes[1]}
              handleChange={() =>
                setCheckBoxes({
                  ...checkBoxes,
                  1: !checkBoxes[1],
                })
              }
            />
            <CustomCheckbox
              label="Youtube"
              checked={checkBoxes[2]}
              handleChange={() =>
                setCheckBoxes({
                  ...checkBoxes,
                  2: !checkBoxes[2],
                })
              }
            />
            <CustomCheckbox
              label="TikTok"
              checked={checkBoxes[3]}
              handleChange={() =>
                setCheckBoxes({
                  ...checkBoxes,
                  3: !checkBoxes[3],
                })
              }
            />
            <CustomCheckbox
              label="Instagram"
              checked={checkBoxes[4]}
              handleChange={() =>
                setCheckBoxes({
                  ...checkBoxes,
                  4: !checkBoxes[4],
                })
              }
            />
          </Box>
        </Box>

        <Box display="flex">
          <InputWithLabel
            label="Follower Count"
            placeholder="10K"
            marginRight={38}
          />
          <InputWithLabel label="Subscriber Count" placeholder="10K" />
        </Box>
        <Box display="flex">
          <InputWithLabel
            label="Handle"
            placeholder="@JohnDoe"
            marginRight={38}
          />
          <InputWithLabel label="Handle" placeholder="JohnDoe" />
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectRegistrationStepFive;
